import { createContext } from 'react';

/** Shared context reference - imported by AppContext.js and useApp.js to avoid circular dependency */
export const AppContext = createContext();
